/* angular:styles/component:css;02f1380172ab13a5ed90b5adf0db17f8bb74f1ca3ed8bd10274d4bb9d707e417;/app/src/app/shared/layout/ag-section/ag-sectionv2.component.ts */
.scroll {
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
}
.content-box {
  background: white;
  border-radius: 20px;
  box-shadow: 1px 1px 8px 0 rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  border: 1px solid transparent;
}
.content-box.ag-size-default {
  padding-top: 30px;
  margin-bottom: 24px;
}
.content-box.ag-size-small {
  padding: 8px;
  margin-bottom: 8px;
}
.content-box.ag-size-none {
  padding: 0px;
  margin-bottom: 0px;
}
.content-box-header {
  margin: 0 32px;
}
.content-box > div:not(:last-of-type) {
  margin-bottom: 16px;
}
.clickable:hover {
  cursor: pointer;
}
mat-icon {
  float: right;
  cursor: pointer;
}
.content-box-title {
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0.5px;
  text-align: left;
  color: #333333;
}
.content-box-content.ag-size-default {
  padding: 0 0px;
}
.virtual-scroll {
  max-height: 400px;
  margin-right: 12px;
  padding-right: 16px;
  overflow-y: auto;
  overflow-x: hidden;
}
.scroll-shadow-top {
  box-shadow: inset 0px 10px 8px -10px rgb(140 140 140 / 75%);
}
::-webkit-scrollbar {
  background-color: transparent;
  width: 5px;
}
::-webkit-scrollbar-track {
  background-color: transparent;
}
::-webkit-scrollbar-thumb {
  background-color: #d8d8d8;
  border-radius: 3px;
  border: transparent;
}
::-webkit-scrollbar-thumb:hover {
  background-color: #babac0;
}
::-webkit-scrollbar-button {
  display: none;
}
/*# sourceMappingURL=ag-sectionv2.component.css.map */
